// Package imports:
import React, { useEffect, useState } from "react";
// Component imports:
import HeadSection from "../../ui-elements/HeadSection/HeadSection";
import Instructions from "./Instructions";
import DisplayBox from "../../ui-elements/DisplayBox/DisplayBox";
import CompaniesTable from "./CompaniesTable";
import Tabs from "../../ui-elements/Tabs/Tabs";
import IndividualsTable from "./IndividualsTable";
import KYCNavBar from "../Company/KYCNavBar/KYCNavBar";
// Type imports:
import { DueDiligenceViewModel, KnowYourCustomer, KnowYourIndividual, ServiceCompanyEmployee } from "../../types/DueDiligenceTypes";
import { Fetched } from "../../types/Types";

const KnowYourCustomerPage: React.FC<DueDiligenceViewModel> = ({
    employees,
    companyKYCPrice,
    individualKYCPrice
}) => {
    return (
        <div className="KCL_due_diligence_page">
            <KYCNavBar />
            <div className="section--white page_body">
                <div className="shell">
                    <HeadSection
                        title="Áreiðanleikakannanir (KYC)"
                    />
                </div>
                <AllSurveyComp
                    employees={employees}
                    companyKYCPrice={companyKYCPrice}
                    individualKYCPrice={individualKYCPrice}
                />
            </div>
        </div>
    )
};

export default KnowYourCustomerPage;

interface IAllSurveyCompProps {
    employees: ServiceCompanyEmployee[];
    companyKYCPrice: number;
    individualKYCPrice: number;
}
const AllSurveyComp: React.FC<IAllSurveyCompProps> = ({ employees, companyKYCPrice, individualKYCPrice }) => {
    // Initialize activeTab from URL hash
    const getInitialTab = (): 'companies' | 'individuals' => {
        const hash = window.location.hash.replace('#', '');
        return hash === 'individuals' ? 'individuals' : 'companies';
    };
    const [activeTab, setActiveTab] = useState<'companies' | 'individuals'>(getInitialTab);
    const [customers, setCustomers] = useState<Fetched<KnowYourCustomer[]>>([]);
    const [individuals, setIndividuals] = useState<Fetched<KnowYourIndividual[]>>([]);
    const [showKYCOverview, setShowKYCOverview] = useState(false);

    // Listen for browser back/forward and update activeTab accordingly
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash.replace('#', '');
            const newTab = hash === 'individuals' ? 'individuals' : 'companies';
            setActiveTab(newTab);
        };
        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    // Update URL hash when activeTab changes
    useEffect(() => {
        const newHash = activeTab === 'individuals' ? '#individuals' : '#companies';
        if (window.location.hash !== newHash) {
            window.location.hash = newHash;
        }
    }, [activeTab]);
    // function to display the table with customer data, customers is a list of KnowYourCustomer objects
    const displayTable = () => {
        return <DisplayBox>
            <Tabs
                tabsSize="lg"
                redirectToTab={activeTab === 'individuals' ? 1 : 0}
                onTabChange={(i) => setActiveTab(i === 0 ? 'companies' : 'individuals')}
                tabs={[{
                    id: 'companies',
                    label: 'Lögaðilar',
                    component: (
                        <CompaniesTable
                            customers={customers}
                            setCustomers={setCustomers}
                            setShowKYCOverview={setShowKYCOverview}
                            companyKYCPrice={companyKYCPrice}
                            employees={employees}
                            showKYCOverviewModal={showKYCOverview && activeTab === 'companies'}
                        />
                    )
                }, {
                    id: 'individuals',
                    label: 'Einstaklingar',
                    component: (
                        <IndividualsTable
                            individuals={individuals}
                            setIndividuals={setIndividuals}
                            setShowKYCOverview={setShowKYCOverview}
                            employees={employees}
                            individualKYCPrice={individualKYCPrice}
                            showKYCOverviewModal={showKYCOverview && activeTab === 'individuals'}
                        />
                    )
                }]}
            />
        </DisplayBox>
    }

    return (
        <div>
            <div className="shell">
                <div className="layout">
                    {/* instructions area */}
                    <Instructions
                        isIndividual={activeTab === 'individuals'}
                    />
                </div >
            </div >

            <div className="section--gray">
                <div className="shell">
                    {displayTable()}
                </div>
            </div>
        </div>

    )
}